import { useEffect, useState } from "react";
import { IconSelectRightArrow, IconVol } from "../icon/master";
import { Popup } from "./Popup";
import { useDevice } from "../AppHooks";

export function Selector({
    className,
    options,
    selected,
    onSelect,
    defaultValue
}: {
    className?: string;
    options: Array<{
        label: string;
        value: string;
    }>;
    selected: string | null;
    defaultValue: string;
    onSelect: (value: string) => void;
}) {
    const [open, setOpen] = useState(false);
    const device = useDevice();
    function closeHandler() {
        setOpen(false)
    }
    useEffect(() => {
        if (open) {
            document.addEventListener('click', closeHandler)
        } else {
            document.removeEventListener('click', closeHandler)
        }
        return () => {
            document.removeEventListener('click', closeHandler)
        }
    }, [open])
    function getSelectedLabel() {
        return options.find((option) => option.value === selected)?.label || defaultValue
    }
    return (
        <div className={`selector-container ${className || ''} ${open ? 'open' : ''}`} onClick={() => setOpen(!open)}>
            <div className="selected-wrapper">
                <span className="text">{getSelectedLabel()}</span>
                <IconSelectRightArrow />
            </div>
            <div className="select-options-wrapper">
                {options.map((option) => (
                    <div
                        key={option.value}
                        className="select-option"
                        onClick={() => onSelect(option.value)}
                    >
                        {option.label}
                    </div>
                ))}
            </div>
            <Popup className="popup-selector-container" show={open && device.isMobile} onClose={closeHandler} headSlot={
                <div className="popup-selector-head">
                    <span className="text">{getSelectedLabel()}</span>
                    {!selected && <IconVol />}
                </div>
            }>
                <div className="select-options-wrapper">
                    {options.map((option) => (
                        <div
                            key={option.value}
                            className="select-option"
                            onClick={() => onSelect(option.value)}
                        >
                            {option.label}
                        </div>
                    ))}
                </div>
            </Popup>
        </div>
    );
}